module.exports = __webpack_public_path__ + "img/home-lazer.07a9fe18.svg";